/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates analytics utilities from the package analytics spec yaml
 *
 * @codegen <<SignedSource::e8a730530bb93e19d0b85114da0581c8>>
 * @codegenCommand yarn workspace @atlaskit/link-picker run codegen-analytics
 */
function createEventPayload(eventKey, attributes) {
  const event = eventKey.split('.');
  return {
    eventType: event[0],
    actionSubject: event[1],
    action: event[2],
    actionSubjectId: event[3],
    attributes: attributes
  };
}

export default createEventPayload;